export const uploadPageFormat = {
    width: '100%', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    marginTop: 10
}

export const loadingSpace = {
    height: "18rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const loadingSpaceA = {
    height: "30rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const uploadLoadingSpace = {
    height: "10rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const noteBox ={
    marginLeft: "5rem",
    display: "flex",
    alignItems: "center",
    gap:"1rem"
}
export const noteStyle = {
    fontWeight: "bold",
    color: "red"
}

export const updateLoadingSpace = {
    height: "20rem",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}